import clsx from "clsx"
import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import { Layout } from "../../../ui/layout"
import { MenuItems } from "../../../ui/organisms/navbar/dto"
import Button from "../../../ui/molecules/button"
import { useEffect, useState } from "react"
import { Pagination } from "../../../ui/organisms/pagination"
import { LogoSpinnerComponent } from "../../../lib/spinner/spinnerLogo"
import { format } from "date-fns"
import { SelectCustom } from "../../../ui/molecules/select"
import {  NotTypeOptions, sot, yes_no } from "../../../utils"
import { GetAllNotifiche2023, setGetAllNotifiche2023HeadQuarters, setGetAllNotifiche2023NotSuperata, setGetAllNotifiche2023NotType } from "./slice"
import { MonitoringNotifiche2023List } from "./list"

export function MonitoringNotifiche2023() {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const Notifiche2023State = useAppSelector(state => state.notifiche2023)

    if (Notifiche2023State.getAllNotifiche2023Status === 'loading') {
        return (
            <LogoSpinnerComponent fullScreen />
        )
    }

    return (
        <Layout menuItem={MenuItems.GESTIONE_CONTROLLO} breadcrumbItems={['Dashboard', 'Gestione Controllo', 'Monitoraggio Notifiche 2023']}
            noPaddingLat
            headerLabel="Monitoraggio Notifiche 2023"
        >
            <div style={{ padding: '24px' }}>
                <div className="w-[100%] flex flex-col gap-[16px] filter" style={{ padding: '24px 0px 0px 0px' }}>
                    <div className="flex flex-row gap-[16px]" style={{ flex: 1, alignItems: 'center' }}>
                        <div style={{ justifyContent: 'left', flex: 1 }} className="flex gap-[16px] items-center">


                            <div style={{ flex: '0.33' }}>
                                <SelectCustom
                                    label="Sede"
                                    placeholder='Sede'
                                    options={sot}
                                    onChange={(value) => dispatch(setGetAllNotifiche2023HeadQuarters(value))}
                                />
                            </div>

                            <div style={{ flex: '0.33' }}>
                                <SelectCustom
                                    label="Tipo Notifica"
                                    placeholder='Tipo Notifica'
                                    options={NotTypeOptions}
                                    onChange={(value) => dispatch(setGetAllNotifiche2023NotType(value))}
                                    
                                />
                            </div>

                            <div style={{ flex: '0.33' }}>
                                <SelectCustom
                                    label="Notifica Superata"
                                    placeholder='Notifica Superata'
                                    options={yes_no}
                                    onChange={(value) => dispatch(setGetAllNotifiche2023NotSuperata(value))}
                                />
                            </div>

                            <div style={{ flex: '0.33', display: 'flex', alignItems: 'center' }}>
                                <span>
                                    <Button
                                        size={"lg"}
                                        iconPosition={"off"}
                                        variant={"outline"}
                                        label="Cerca"
                                        color={"blue"}
                                        onClick={
                                            () => {
                                                dispatch(GetAllNotifiche2023(Notifiche2023State.GetAllNotifiche2023Filters))
                                            }
                                        }
                                    />
                                </span>
                            </div>
                        </div>
                        {/* <div style={{ display: 'flex', justifyContent: 'right', flex: 0.3 }}>
                            <Pagination
                                numbResults={m24OpenState.GetAllFaseAvvioResponse ? m24OpenState.GetAllFaseAvvioResponse.total : 0}
                                pages={m24OpenState.GetAllFaseAvvioResponse?.totalPage || 1}
                                currentPage={m24OpenState.GetAllNotifiche2023Filters.page ? m24OpenState.GetAllNotifiche2023Filters.page : 0}
                                detailsResults={'clienti'}
                                setPage={
                                    (page) => {
                                        dispatch(setGetAllNotifiche2023FiltersPage(page))
                                        dispatch(GetAllFaseAvvio(m24OpenState.GetAllNotifiche2023Filters))
                                    }
                                }
                            />
                        </div> */}
                    </div>
                </div>
                <MonitoringNotifiche2023List />
            </div>
        </Layout>
    )
}